import { render } from "./OtpPad.vue?vue&type=template&id=e8c22e64"
import script from "./OtpPad.vue?vue&type=script&lang=js"
export * from "./OtpPad.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LENOVO\\Desktop\\Septem\\mobins.frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__